import React from 'react';
import './Hero.css';

const Hero = ({ handleLoginClick }) => {
  return (
    <section className="hero-section">
      <div className="hero-image">
        <img 
          src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
          alt="Utility infrastructure and water meter installation" 
          className="hero-bg-image" 
        />
        <div className="hero-overlay">
          <div className="hero-content">
                        <h1 className="hero-title">Carmel Lahaina Utility Services</h1>
            <h2 className="hero-subtitle">Utility Installation & General Contracting Services</h2>
          </div>
        </div>
      </div>
      
      <div className="hero-text-section">
        <div className="hero-divider"></div>
                    <h3 className="hero-tagline">Professional Utility & Contracting Services</h3>

                    <p className="hero-description">
                      We specialize in utility installation and general contracting services for residential and commercial properties. 
                      Our experienced team handles water, gas, electrical, and telecommunications installations with precision and care. 
                      From initial planning to final inspection, we ensure every project meets the highest standards of quality and safety. 
                      Our comprehensive contracting services include construction, renovation, and maintenance solutions tailored to your specific needs.
                    </p>
        
        <div className="hero-cta">
          <button className="btn btn-primary" onClick={handleLoginClick}>Bill Pay</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
